import WrappedPlaidButton from './WrappedPlaidButton';

export default WrappedPlaidButton;
